module.exports = __webpack_public_path__ + "static/media/t1.36b8a379.png";